module.exports = __webpack_public_path__ + "static/media/property-disctrict.1d436cb1.png";